import { useSurveyDashboardStore } from '../../store/useSurveyDashboard.store';
import SchoolsFilter from '@/components/SchoolsFilter';

export default function SurveyDashboardSchoolsFilter() {
  const { selectedSchoolsIds, updateSelectedSchools } = useSurveyDashboardStore((store) => ({
    selectedSchoolsIds: store.selectedSchoolsIds,
    updateSelectedSchools: store.updateSelectedSchools,
  }));

  const handleSchoolsChange = (schoolIds: string[]) => {
    updateSelectedSchools(schoolIds);
  };

  return (
    <div className="mx-auto mt-6 flex w-full flex-col items-center justify-center">
      <SchoolsFilter selectedSchoolsIds={selectedSchoolsIds} onChange={handleSchoolsChange} showChips={true} />
    </div>
  );
}
